import axios from "axios";

export const getApiErrorMessage = (apiError, fallbackMessage) => {
  return (
    apiError?.response?.data?.message ||
    apiError?.response?.data?.error ||
    apiError?.message ||
    fallbackMessage
  );
};

export const getPhoneConfig = async (accessToken) => {
  const response = await axios.get("/api/phone/config", {
    headers: {
      Authorization: accessToken,
    },
  });

  return response.data;
};

export const postPhoneCallLog = async (accessToken, payload) => {
  const response = await axios.post("/api/phone/call-log", payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response.data;
};
